import { render, staticRenderFns } from "./VsPopupCustom.vue?vue&type=template&id=0c2c02b7&lang=html"
import script from "./VsPopupCustom.vue?vue&type=script&lang=js"
export * from "./VsPopupCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports